import { AxiosResponse } from 'axios'
import { api } from '../config'

export const balanceWithdrawal = async (eventId: string) => {
  const { status }: AxiosResponse = await api.post(
    `/api/creators/events/${eventId}/balance/withdrawal`
  )

  return status
}
